import { adminCompanyArgs, adminFileAuth } from './adminAuth';
import {supabase} from './supabaseClient';
export function docHubAuth(company,actor){
 if(!['admin','company'].includes(actor?.role))throw new Error('Doc Hub is available to HR/Admin only.');
 if(company?.config?.doc_hub_enabled!==true)throw new Error('Doc Hub is disabled for this company. Contact Super Admin.');
 return adminCompanyArgs(company);
}
export async function docHubCall(company,actor,action,payload={}){
 const {data,error}=await supabase.rpc('doc_hub_admin',{...docHubAuth(company,actor),p_action:action,p_payload:payload});
 if(error)throw new Error(error.code==='PGRST202'||/function.*does not exist|schema cache/i.test(error.message||'')?'Doc Hub database setup is required. Run supabase/doc_hub_update.sql, then refresh.':error.message);
 return data;
}
export async function uploadHubDocument(company,actor,file,metadata){
 docHubAuth(company,actor);
 const body=new FormData();body.append('auth',JSON.stringify(await adminFileAuth(company)));body.append('metadata',JSON.stringify(metadata));body.append('file',file);
 const response=await fetch('/api/doc-hub',{method:'POST',body}),data=await response.json().catch(()=>({error:'Document service is unavailable.'}));
 if(!response.ok)throw new Error(data.error||'Document upload failed.');if(!data.document?.id)throw new Error('Could not confirm the uploaded document. Retry the same upload.');return data;
}
export async function hubFileAction(company,actor,action,documentId){
 const response=await fetch('/api/doc-hub',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({auth:(docHubAuth(company,actor),await adminFileAuth(company)),action,document_id:documentId})});
 if(!response.ok){const data=await response.json().catch(()=>({}));throw new Error(data.error||'Document operation failed.');}
 if(action==='download'){
  const blob=await response.blob(),url=URL.createObjectURL(blob),link=document.createElement('a');link.href=url;link.download=decodeURIComponent(response.headers.get('X-Document-Filename')||'document');link.click();setTimeout(()=>URL.revokeObjectURL(url),60000);return;
 }
 return response.json();
}
